import React from 'react';

const ServiceDetails = () => {
    return (
        <section className="backlight-both">
            <div className="stg-row stg-bottom-gap-l">
                <div className="stg-col-7">
                    <h2 data-split-appear="fade-up" data-unload="fade-up">Here's how we take your brand from spark to wildfire:</h2>
                </div>
                <div className="stg-col-5"></div>
            </div>
            <div className="stg-row stg-bottom-gap stg-valign-middle stg-m-bottom-gap-l" data-unload="fade-left">
                <div className="stg-col-3 stg-offset-3 stg-tp-col-6 stg-m-bottom-gap" data-appear="fade-right">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details01.jpg" alt="Branding 01" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-6" data-appear="fade-right" data-delay="100">
                    <span className="infocolors-label">Branding 01</span>
                    <h4>Unveiling Your Essence</h4>
                    <p>Here is where the journey begins. We begin by getting to know you intimately. We delve into your vision, values, target audience, and competitive landscape. Through workshops, interviews, and deep dives into your industry, we uncover the unique DNA of your brand.</p>
                </div>
            </div>
            <div className="stg-row stg-bottom-gap stg-valign-middle stg-tp-row-reverse stg-m-bottom-gap-l" data-unload="fade-right">
                <div className="stg-col-3 stg-tp-col-6 stg-m-bottom-gap" data-appear="fade-left">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details02.jpg" alt="Branding 02" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-6" data-appear="fade-left" data-delay="100">
                    <span className="infocolors-label">Branding 02</span>
                    <h4>Crafting Your Narrative</h4>
                    <p>Once we understand your core, we weave it into a captivating story. We define your brand personality, your values, and the message you want to share with the world. This becomes the heart and soul of your brand, the thread that connects everything you do.</p>
                </div>
                <div className="stg-col-3"></div>
            </div>
            <div className="stg-row stg-bottom-gap stg-valign-middle stg-m-bottom-gap-l" data-unload="fade-left">
                <div className="stg-col-3 stg-offset-3 stg-tp-col-6 stg-m-bottom-gap" data-appear="fade-right">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details03.jpg" alt="Branding 03" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-6" data-appear="fade-right" data-delay="100">
                    <span className="infocolors-label">Branding 03</span>
                    <h4>Visualizing Your Fire</h4>
                    <p>With your story as our guide, we translate it into a stunning visual identity. We design a logo that embodies your essence, a color palette that evokes emotions, and typography that reflects your voice. Every visual element tells your story, leaving an impression on your audience.</p>
                </div>
            </div>
            <div className="stg-row stg-bottom-gap stg-valign-middle stg-tp-row-reverse stg-m-bottom-gap-l" data-unload="fade-right">
                <div className="stg-col-3 stg-tp-col-6 stg-m-bottom-gap" data-appear="fade-left">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details04.jpg" alt="Branding 04" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-6" data-appear="fade-left" data-delay="100">
                    <span className="infocolors-label">Branding 04</span>
                    <h4>Shaping Your Voice</h4>
                    <p>Your brand doesn't just have a look; it has a voice. We craft messaging that resonates with your target audience, sparking conversations and building trust. From website copy to social media captions, we ensure your voice is consistent, authentic, truly yours.</p>
                </div>
                <div className="stg-col-3"></div>
            </div>
            <div className="stg-row stg-valign-middle" data-unload="fade-left">
                <div className="stg-col-3 stg-offset-3 stg-tp-col-6 stg-m-bottom-gap" data-appear="fade-right">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/service-details05.jpg" alt="Branding 05" width="960" height="960" />
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-col-6" data-appear="fade-right" data-delay="100">
                    <span className="infocolors-label">Branding 05</span>
                    <h4>Building Your Brand Blueprint</h4>
                    <p>We don't leave you with just a logo and a tagline. We create a comprehensive brand guide, your roadmap for successful brand implementation. This guide outlines your brand voice, visual identity, messaging guidelines, and even tone of voice, ensuring everyone who interacts with your brand can carry the torch.</p>
                </div>
            </div>
        </section>
    );
};

export default ServiceDetails;
